export default __webpack_public_path__ + "static/media/Ash_Oil_Painting.cc0a88dd.JPG";